import constants from "../config/constants";
import { postRequest } from "../libs/AxiosService.util";


export async function serviceGetLeadsMaster(params) {
  return await postRequest("contacts/leads", params);
}

export async function serviceGetLeadsKanbanList(params) {
  return await postRequest("contacts/leads/kanban", params);
}

export async function serviceGetLeadDetail(params) {
  return await postRequest("contacts/leads/detail", params);
}

export async function serviceGetLeadNotes(params) {
  return await postRequest("contacts/leads/notes", params);
}

export async function serviceAddLeadNote(params) {
  return await postRequest("contacts/leads/notes/create", params);
}

export async function serviceGetLeadMetrics(params) {
  return await postRequest("contacts/leads/metrics", params);
}

export async function serviceGetPayoutQueries(params) {
  return await postRequest("doctor/payouts/queries", params);
}

export async function serviceCreatePayoutProcess(params) {
  return await postRequest("doctor/payouts/process", params);
}

export async function serviceGetPayoutDetail(params) {
  return await postRequest("doctor/payouts/detail", params);
}
export async function serviceGetCallAnalysis(params) {
  return await postRequest("call-recording-analysis/getByCustomerQueryIdOrAppointmentId", params);
}
export async function serviceReanalyzeCall(params) {
  return await postRequest("call-recording-analysis/reanalyze", params);
}
export async function serviceAddPayout(params) {
  return await postRequest("doctor/payouts/add/adjustment", params);
}
export async function serviceGetDoctorBalance(params) {
  return await postRequest("doctor/payouts/balance", params);
}